var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.page === 'apps')?_c('Appointments'):(_vm.page === 'questions')?_c('Questions'):(_vm.page === 'feed')?_c('Feed'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }